<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <rect width="32" height="32" fill="none"/>
    <g>
      <path class="filled" d="M16,3.243A12.757,12.757,0,1,0,28.757,16,12.756,12.756,0,0,0,16,3.243Zm1.8,19.64H14.2V16.639h3.6Zm0-9.744H14.2V9.117h3.6Z" fill="currentColor"/>
      <rect class="cutout" x="14.2" y="16.639" width="3.6" height="6.244" fill="#fff"/>
      <rect class="cutout" x="14.2" y="9.117" width="3.6" height="4.022" fill="#fff"/>
    </g>
  </g>
</svg>
